// HTMLの生成はRails側で行うため、全体はComponentを作らない
import {
  onMounted,
  ref
} from 'vue'

import Properties from './Properties.vue'

export default {
  components: {
    Properties
  },

  setup() {
    const backText = ref()
    const mode = ref('page')

    const handleClickBack = () => {
      mode.value = 'page'
      setTimeout(() => window.scroll({ top: 0 }), 10)
    }

    const handleClickImage = () => mode.value = 'images'

    onMounted(() => {
      const element = document.querySelector('.c-page-ttl')
      if (element) {
        backText.value = element.innerText
      }
    })

    return {
      backText,
      mode,
      handleClickBack,
      handleClickImage,
    }
  },
}
